import React from "react";
import Banner from "./Banner";
// import Survey from "./Survey";
import GetStartedForm from "./getStartedForm";
import SEO from "../SEO";
import { useEffect } from "react";
import ReactGA from "react-ga4";

const GetStarted = () => {
	useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/get-started",
      title: "Get Started | SynergyCare Foundation",
    });
  });
	return (
		<div className='font-sans'>
			<SEO
				title='Get Started | SynergyCare Foundation'
				description='Fill the form to get started with SynergyCare Foundation'
				name='SynergyCare Foundation'
				type=''
			/>
			<Banner />
			<GetStartedForm />
			{/* <Survey /> */}
		</div>
	);
};

export default GetStarted;
